export default {
  title: {
    userManagement: 'User Management',
    roleManagement: 'Role Management',
    userAdd: 'Add User',
    userEdit: 'Edit User',
    resetPassword: 'Reset Password',
    accountCancellation: 'Account Cancellation'
  },
  menu: 'User Management',
  label: {
    name: 'Name',
    company: 'Company',
    email: 'Email Address',
    role: 'Role',
    updateTime: 'Update Time',
    status: 'Status',
    option: 'Operation',
    companyName: 'Company Name',
    addUser: 'Add User',
    editUser: 'Edit User',
    firstName: 'First Name',
    lastName: 'Last Name',
    chineseName: 'Name in Chinese Characters',
    primaryEmail: 'Primary Email Address',
    secondaryEmail: 'Secondary Email Address',
    mobile: 'Mobile',
    employeeId: 'Employee ID',
    reportTo: 'Report To',
    programType: 'Program Type',
    clientName: 'Client Name',
    costCentre: 'Cost Center',
    roleType: 'Role Type',
    roleSource: 'Available Roles:',
    roleTarget: 'Assigned Roles:',
    roleHead: "Assign {name}'s Role at {company} {email}",
    resetPassword: 'Reset Password',
    password: 'New Password:',
    confirmPassword: 'Password Again:',
    emailOrMobile: 'Email/Mobile',
    emailAfterCancellation: 'Change To',
    disableAccount: 'Disable Account',
    unbindWeChat: 'Unbind WeChat',
    cancellation: 'Cancellation'
  },
  placeholder: {
    firstName: 'Please input first name',
    lastName: 'Please input last name',
    chineseName: 'Please input chinese name',
    company: 'Please select company',
    secondaryEmail: 'Please input secondary email',
    mobile: 'Please input mobile',
    employeeId: 'Please input employee id',
    reportTo: 'Please select report manager',
    programType: 'Please select program type',
    clientName: 'Please input client name',
    costCentre: 'Please input cost centre',
    roleType: 'Please select role type',
    role: 'Please select role',
    email: 'Please input email',
    primaryEmail: 'Please input primary email',
    password: 'Please input password',
    confirmPassword: 'Please input password again',
    search: 'Search (Email/Name)'
  },
  btn: {
    addUser: 'Add User',
    exportUser: 'Export User',
    resetPassword: 'Reset Password',
    role: 'Role'
  },
  message: {
    optionSuccess: 'Option Success',
    optionField: 'Option Field',
    userTip: '{activeCount} Active Accounts(s) of {totalCount} Total Accounts Available.',
    userRequired: 'This field is required',
    emailExist: 'a user is already registered with this email address',
    emailValid: 'Enter a valid e-mail address.',
    mobileExist: 'The mobile number has already been bound.',
    resetPasswordError: 'Can not reset password more than 5 times in 24 hours.',
    resetPasswordSuccess: 'Reset password email has sent, please check in few minutes.',
    expireDateClosed: 'Please contact AJINGA to add additional accounts.',
    confirmPasswordSame: 'Please make sure the two passwords are the same.',
    cancellationSuccess: 'Cancellation success'
  }
}
